export default {
    methods: {
        dateFormat(value = null) {
            return new Intl.DateTimeFormat('en-CA', {
                year: 'numeric', month: '2-digit', day: '2-digit', hour12: false,
                hour: '2-digit', minute: '2-digit', second: '2-digit',
            }).format(value ?? new Date()).replace(',', '')
        }
    }
    }